<div>
  <mat-card appearance="outlined"
            class="bank-accounts-card">
    <mat-card-title>
      <div layout="row"
           layout-align="space-between center">
        <span class="edit-screen-card-title"
              [translate]="'clients.bankAccount'">Bank accounts</span>
        <button [disabled]="'USER_BANK_ACCOUNT_WRITE' | isUnauthorized | async"
                mat-raised-button
                class="button-actions add-bank-account"
                (click)="addBankRecord()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-card-title>

    <mat-card-content>
      @if (isLoading) {
      <div class="progress-spinner-container">
        <mat-spinner class="progress-spinner"
                     strokeWidth="10"
                     [diameter]="100"></mat-spinner>
      </div>
      }

      @if (!isLoading && bankAccountForms.controls.length === 0) {
      <div class="padding-bottom-16px"
           layout="row"
           layout-align="center center">
        <h4 [translate]="'clients.noBankAccounts'">Няма качени банкови сметки</h4>
      </div>
      }

      @if (!isLoading && bankAccountForms.controls.length > 0) {
      <div layout="row">
        <div flex-gt-xs="100"
             flex="100">
          @for (bankAccount of bankAccountForms.controls; track bankAccount; let i = $index) {
          <div [itfgPermissions]="['USER_BANK_ACCOUNT_WRITE']"
               layout="column"
               class="section-divider">
            <div>
              <mat-card appearance="outlined">
                <mat-card-content flex="full-width"
                                  class="margin-left-2">
                  <form [formGroup]="bankAccount"
                        layout="column">

                    <mat-form-field class="margin-right-2 full-width">
                      <input matInput
                             type="text"
                             (paste)="trimEmptyChars(i, bankAccount.get('iban'), $event)"
                             formControlName="iban"
                             placeholder="{{
                              (bankAccount.get('iban').value | formatIban: 'bankIdCode')
                              !== bankAccount.get('iban').value ?
                              (bankAccount.get('iban').value | formatIban: 'bankIdCode') : ('clients.ibanBank' | translate)
                            }}">
                      <mat-label>{{
                        (bankAccount.get('iban').value | formatIban: 'bankIdCode')
                        !== bankAccount.get('iban').value ?
                        (bankAccount.get('iban').value | formatIban: 'bankIdCode') : ('clients.ibanBank' | translate)
                        }}</mat-label>
                      @if (bankAccount.get('iban').errors) {
                      <mat-error [translate]="'forms.invalidFormat'">Invalid format</mat-error>
                      }
                    </mat-form-field>

                    <div class="relative-positioning">
                      @if (i != indexOfEditedAccount && bankAccount.get('id').value) {
                      <div class="file-input-field-mask"
                           (click)="$event.preventDefault();"></div>
                      }
                      <div class="flex-center">
                        <mat-form-field (click)="fileUpload.triggerUploadButton()"
                                        flex>
                          <input matInput
                                 placeholder="{{'clients.documentOrImage' | translate}}"
                                 #fileResult
                                 formControlName="userDocument"
                                 [value]="bankAccount.get('userDocument').value?.name || bankAccount.get('userDocument').value || ''"
                                 readonly />
                          @if (bankAccount.get('userDocument').errors &&
                          bankAccount.get('userDocument').errors.invalidField) {
                          <mat-hint class="override-color"
                                    [translate]="'clients.fileNameTooLong'"
                                    [translateParams]="{value: MAX_FILE_NAME_LENGTH}">
                            Some of the fields are invalid
                          </mat-hint>
                          }
                          @if (indexOfEditedAccount === i) {
                          <mat-hint
                                    [translate]="'clients.selectDocumentInProperFormat'">selectDocumentInProperFormat</mat-hint>
                          }
                        </mat-form-field>
                        @if (bankAccount.get('userDocument').value) {
                        <button mat-icon-button
                                type="button"
                                matTooltip="{{ 'clients.deleteDocumentTooltip' | translate }}"
                                (click)="clearFileInput(i, $event)"
                                [disabled]="i != indexOfEditedAccount && bankAccount.get('id').value">
                          <mat-icon>cancel</mat-icon>
                        </button>
                        }
                        <itfg-file-upload #fileUpload
                                          (fileSelected)="onFileSelected($event, bankAccount.get('userDocument'))">
                        </itfg-file-upload>
                      </div>
                    </div>

                    <div class="margin-left-2"
                         flex="100"
                         layout="row"
                         layout-align="space-between center">
                      <mat-checkbox formControlName="verified">
                        {{'global.verified' | translate}}
                      </mat-checkbox>

                      <div layout="row"
                           layout-align="end center">
                        @if (bankAccount && indexOfEditedAccount != i && (bankAccount.get('id').value !== null)) {
                        <button flex
                                mat-raised-button
                                class="button-actions bank-account-buttons"
                                type="button"
                                [disabled]="'USER_BANK_ACCOUNT_WRITE' | isUnauthorized | async"
                                (click)="editBankAccountRecord(i, bankAccount)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        }

                        @if (client?.id && (indexOfEditedAccount === i || !bankAccount.get('id').value)) {
                        <button flex
                                mat-raised-button
                                class="button-actions bank-account-buttons"
                                type="button"
                                [disabled]="!saveBtnEnabled[i] || ('USER_BANK_ACCOUNT_WRITE' | isUnauthorized | async)"
                                [ngClass]="{
                                  'mat-elevation-z2': true,
                                  'enabled-save-btn': saveBtnEnabled[i] && !('USER_BANK_ACCOUNT_WRITE' | isUnauthorized | async),
                                  'disabled-save-btn': !saveBtnEnabled[i] || ('USER_BANK_ACCOUNT_WRITE' | isUnauthorized | async)
                                }"
                                (click)="saveEditedBankAccountRecord(bankAccount)">
                          <mat-icon>save</mat-icon>
                        </button>
                        }

                        <button flex
                                mat-raised-button
                                type="button"
                                [disabled]="'USER_BANK_ACCOUNT_DELETE' | isUnauthorized | async"
                                (click)="deleteBankRecord(i, bankAccount)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>

                    <div>
                      @if (bankAccount.errors && bankAccount.errors['invalidField']) {
                      <mat-hint class="override-color"
                                [translate]="'clients.ibanSaveProblem'">Some of the fields are invalid
                      </mat-hint>
                      }
                    </div>

                  </form>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
